import React from 'react';
import { SanityTitleSection } from 'graphql-types';
import * as styles from './titleSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityTitleSection;
}

export const TitleSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();

  return (
    <div className={styles.wrapper}>
      <h1>{findTranslation(section._rawTitle, lang, defaultLang)}</h1>
    </div>
  );
};
